const IndustriesRoutes = {
  getAllIndustries: "/industry/industryGetAll"
}

export default IndustriesRoutes;